import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import ReportingPortalHeaderPowerBi from './ReportingPortalHeaderPowerBi';
import {getCompanyFacilities} from '../../reducers/settings';
import {theme} from '@partssourceinc/react-ui-core';
import 'components/css/reportingportal.css';
import ReportingPortalDashboardItemPowerBi from './ReportingPortalDashboardItemPowerBi';
import axios from 'axios';
import {updateUserPortalWidgetsOrder} from './../../reducers/user';

const MultiGridPage = styled.div.attrs({className: 'multi-grid-page'})`
    width:100%;
    background: #f1f1f1;
    margin: 0 -20px; 
    padding: 0 20px;
    min-height: calc(100vh - 592px);
    @media screen and (min-width: ${theme.screenXLMin}) {
        margin: 0 -50px; 
        padding: 0 50px;
    }
    @media screen and (max-width: ${theme.screenLGMax}) {
        margin: 0 -50px; 
        padding: 0 50px;
    }
    @media screen and (max-width: ${theme.screenMDMax}) {
        margin: 0 -20px; 
        padding: 0 20px;
    }
    @media screen and (max-width: ${theme.screenSMMax}) {
        margin: 0 -20px; 
        padding: 0 20px;
    }
    @media screen and (max-width: ${theme.screenXsMax}) {
        margin: 0 -20px; 
        padding: 0 20px;
    }
    @media screen and (max-width: 320px) {
        margin: 0 -20px; 
        padding: 0 20px;
    }
`;

const ReportingPortalDashboardPowerBi = () => {
    const [widgets, setWidgets] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const portal = useSelector(state => state.user.userDashboardSettings.data.portal);
    const rootCompanyId = useSelector(state => state.user.companyId);
    const facilities = useSelector(state => state.settings.facilities);
    const sortedFacilities = facilities ? [...facilities].sort((a, b) => a.name.localeCompare(b.name)) : [];
    const dispatch = useDispatch();

    useEffect(() => {
        // Fetch facilities for the user
        dispatch(getCompanyFacilities());
    }, [dispatch]);

    useEffect(() => {
        // Set initial selected facility
        if (sortedFacilities?.length > 0) {
            setSelectedCompanyId(sortedFacilities[0].id);
        }
    }, [facilities]);
    
    const saveWidgetOrder = (items) => {
        let req = _.cloneDeep(portal);
        req.widgets = items;
        axios.post('reporting-portal/user-portal-widgets/reorder', req)
    }

    const updateWidgetsOrder = async (items) => {
        setWidgets(items);
        saveWidgetOrder(items);
        dispatch(updateUserPortalWidgetsOrder(items));
    }
      
    useEffect(() => {
        setWidgets(portal.widgets);
    }, [portal, portal.widgets]);

    return (<MultiGridPage>
        {
            _.isNil(rootCompanyId) && (
                <div style={{height: '400px'}} className="loading-dashboard">
                    <div className="loader" />
                </div> 
            )
        }
        {
            !_.isNil(rootCompanyId) && (
                <>

                    <ReportingPortalHeaderPowerBi 
                        updateWidgetsOrder={updateWidgetsOrder} 
                        showDateRangeLabel={false}
                        facilities={sortedFacilities}
                        selectedCompanyId={selectedCompanyId}
                        onFacilityChange={setSelectedCompanyId}
                    />
                    <div className="widget-container" style={{marginTop: '20px'}}>
                        {widgets && widgets.map(widget => (
                            <div className="widget-item" key={`${widget.id}-${selectedCompanyId}`}>
                                <ReportingPortalDashboardItemPowerBi 
                                    widget={widget}
                                    selectedCompanyId={selectedCompanyId}
                                />
                            </div>
                        ))}
                    </div>
                </>
            )
        }
    </MultiGridPage>);
}

export default ReportingPortalDashboardPowerBi;
